export { useHasAccessForPlatform } from './use-has-access-for-platform';
